import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

import { codeStates, decisions } from '../constants'
import Actions from './Actions/Actions'
import CodeText from './CodeText/CodeText'
import DiscardedContent from './DiscardedContent/DiscardedContent'
import MatchedContent from './MatchedContent/MatchedContent'
import PendingContent from './PendingContent/PendingContent'
import ReadyToUpdateContent from './ReadyToUpdateContent/ReadyToUpdateContent'
import WarningCodeText from './WarningCodeText/WarningCodeText'
import { codeTypes } from './constants'
import * as Styles from './styles'

const CodeRow = ({
  codeType,
  currentCode,
  currentDescription,
  proposedCode,
  proposedDescription,
  codeState,
  decision,
  showHts,
  onAccept,
  onDiscard,
  onUndo,
  onRestore,
}) => {
  const theme = useTheme()
  const { t } = useTranslation()
  const isHs = codeType === codeTypes.hs
  const labelKey = isHs ? 'Código HS actual' : 'Código HTS actual'
  const missingKey = isHs ? 'Sin HS Code' : 'Sin HTS Code'

  return (
    <Styles.Container>
      <Styles.Row>
        <Styles.Column>
          <Text type="allCapsM" color={theme.colors.text.muted}>
            {t(labelKey)}
          </Text>
          {codeState === codeStates.missing && <WarningCodeText code={t(missingKey)} />}
          {codeState === codeStates.invalid && <WarningCodeText code={t('Código inválido')} />}
          {(codeState === codeStates.match || codeState === codeStates.mismatch) && <CodeText code={currentCode} />}
          {currentDescription && (
            <Text type="bodyMRegular" color={theme.colors.text.default}>
              {currentDescription}
            </Text>
          )}
        </Styles.Column>
        <Styles.RightSection>
          {codeState === codeStates.match && <MatchedContent proposedCode={proposedCode} isHs={isHs} />}
          {codeState !== codeStates.match && decision === decisions.pending && (
            <PendingContent proposedCode={proposedCode} proposedDescription={proposedDescription} />
          )}
          {decision === decisions.accepted && (
            <ReadyToUpdateContent proposedCode={proposedCode} proposedDescription={proposedDescription} />
          )}
          {decision === decisions.discarded && <DiscardedContent isHs={isHs} showHts={showHts} />}
        </Styles.RightSection>
      </Styles.Row>
      <Styles.ActionsWrapper>
        <Actions
          codeState={codeState}
          decision={decision}
          onAccept={onAccept}
          onDiscard={onDiscard}
          onUndo={onUndo}
          onRestore={onRestore}
        />
      </Styles.ActionsWrapper>
    </Styles.Container>
  )
}

export default CodeRow
